<template>
    <div class="context common_table_view">
        <div class="header">
            <div class="search search_box">
            </div>
            <div class="btn_box">
                <el-button type="primary"
                           plain
                           @click="addRule"
                           size="small">
                    添加规则
                </el-button>
                <el-button @click="changeOrder"
                           v-if="changeSort"
                           size="small">
                    更换顺序
                </el-button>
                <el-button @click="setOrder"
                           v-else
                           size="small">
                    保存顺序
                </el-button>
            </div>
        </div>

        <div class="table">
            <el-table :data="tableData"
                      stripe
                      ref="dragTable"
                      row-key="task_id"
                      v-loading="listLoading"
                      width="100%"
                      height="100%">
                <el-table-column type="index" width="65" label="序号"></el-table-column>
                <el-table-column v-for="(item, index) in columnData"
                                 :prop="item.prop"
                                 :label="item.label"
                                 :width="item.width"
                                 :formatter="item.formatter"
                                 :fixed="item.fixed"
                                 show-overflow-tooltip
                                 :key="index"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <span class="table_btn"
                              @click="editRow(scope.row)">
                            <i class="el-icon-edit"></i>
                            编辑
                        </span>
                        <span class="table_del_btn"
                              @click="delRow(scope.row)">
                            <i class="el-icon-delete"></i>
                            删除
                        </span>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import Sortable from "sortablejs";
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "tableView",
        data() {
            const showRepeat = (row, column, cellValue, index) => {
                let text = cellValue == 1 ? '仅一次' : cellValue == 2 ? '可重复多次' : '';
                return text
            };
            const showMaximum = (row, column, cellValue, index) => {
                let text = row.repeat == 1 ? '' :
                    cellValue == 1 ? '不限' :
                    cellValue == 2 ? `累计最高分：${row.maximum}` :
                        cellValue == 3 ? `T次累计最高分：${row.maximum}` :
                            '';
                return text
            };
            return {
                searchForm: {
                    input: ''
                },

                tableData: [],
                columnData: [
                    {label: '事件类型', prop: 'event_name'},
                    {label: '获取次数', prop: 'repeat', formatter: showRepeat},
                    {label: '最高限制', prop: 'maximum_type', formatter: showMaximum},
                    {label: '每次积分数', prop: 'score'},
                    {label: '任务描述', prop: 'wording'},
                ],
                listLoading: false,

                changeSort: true, // 不可拖拽
                sortable: null, // 拖拽
            }
        },
        mounted() {
            this.getTableData();
            this.rowDrop()
        },
        methods: {
            ...mapMutations('manageData', {
                setJIFENRuleData: 'setJIFENRuleData'
            }),
            getTableData() {
                this.httpGet('/points/task').then(res => {
                    this.tableData = res.data
                })
            },

            rowDrop() {
                // const tbody = document.querySelector('.el-table__body-wrapper tbody');
                const tbody = this.$refs.dragTable.$el.querySelector('.el-table__body-wrapper > table > tbody');
                const _this = this;
                //  指定父元素下可被拖拽的子元素
                this.sortable = Sortable.create(tbody, {
                    draggable: ".el-table__row", //  指定父元素下可被拖拽的子元素
                    disabled: this.changeSort, // 是否开启拖拽
                    onEnd({newIndex, oldIndex}) {
                        const currRow = _this.tableData.splice(oldIndex, 1)[0];
                        _this.tableData.splice(newIndex, 0, currRow);
                    }
                });
            },

            addRule() {
                this.setJIFENRuleData(null);
                this.$emit('changeTopTab', 'addView')
            },
            editRow(row) {
                this.setJIFENRuleData(row);
                this.$emit('changeTopTab', 'addView')
            },
            delRow(row) {
                this.$confirm(`确定要删除${row.event_name} 这条规则么？`).then(() => {
                    this.httpDel(`/points/task/${row.task_id}`).then(res => {
                        this.$message.success('删除成功');
                        this.getTableData()
                    })
                })
            },


            changeOrder() {
                this.changeSort = false;
                this.sortable.options.disabled = this.changeSort
            },
            setOrder() {
                console.log('保存顺序');
                this.changeSort = true;
                this.sortable.options.disabled = this.changeSort;

                let params = [];
                this.tableData.forEach(v => {
                    params.push(v.task_id)
                });
                this.httpPost('/points/task/update_order', params).then(res => {
                    this.$message.success('保存顺序成功！');
                    this.getTableData()
                })
            },
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>